export const TIPO_CASO = {
    VISTORIA: {
        ID_TIPO_CASO: 10,
    },
};
